import { PlanFor } from "routes/plan/plan"
import { WeekPlanner } from "routes/plan/week-planner"
import { Bound } from "lib/@components/binding/Bound"
import { usePlanRoot } from "lib/use-plan-root"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { FEATURE_FLAG_52_WEEK_PLANNER } from "./weekly-planner.runtime"
import { Feature } from "lib/@components/feature"

export function WeeklyPlanner() {
    const plan = usePlanRoot()
    const { parentItem } = useBoundContext()
    return (
        <Feature feature={FEATURE_FLAG_52_WEEK_PLANNER}>
            <Bound treeId={plan.id}>
                <PlanFor id={plan.id}>
                    <Bound parentItem={parentItem}>
                        <WeekPlanner />
                    </Bound>
                </PlanFor>
            </Bound>
        </Feature>
    )
}
